<mat-icon fontSet="fad" inline class="batteryStatusIcon" [fontIcon]="batteryLevelIcon" />
